import React from 'react';
import PropTypes from 'prop-types';

import LaborTDABCArtifact from './LaborTDABCArtifact';
import LaborTDABCReal from './LaborTDABCReal';

function LaborCostTDABC({
  previousLotList,
  currentLot,
  isCurrentAsProductLot,
  place,
  useTDABCArtifact,
}) {
  return (
    <div>
      {useTDABCArtifact ? (
        <LaborTDABCArtifact
          place={place}
          previousLotList={previousLotList}
          currentLot={currentLot}
        />
      ) : (
        <LaborTDABCReal
          previousLotList={previousLotList}
          currentLot={currentLot}
          isCurrentAsProductLot={isCurrentAsProductLot}
          place={place}
        />
      )}
    </div>
  );
}

export default LaborCostTDABC;

LaborCostTDABC.propTypes = {
  previousLotList: PropTypes.arrayOf(PropTypes.object),
  currentLot: PropTypes.object,
  isCurrentAsProductLot: PropTypes.bool,
  place: PropTypes.object,
  useTDABCArtifact: PropTypes.bool,
};
